var _a;
import config from '@visma/public.config';
import definition from 'api/schema.json';
const baseURL = (_a = config.backend) === null || _a === void 0 ? void 0 : _a.baseURL;
if (baseURL) {
    const isAbsoluteURL = baseURL.indexOf('://') > 0 || baseURL.indexOf('//') === 0;
    definition.servers[0].url = isAbsoluteURL
        ? baseURL
        : globalThis.location.origin + baseURL;
}
//# sourceMappingURL=setBackendBaseURL.js.map